<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20.52 20">
        <path 
        id="icono-atras" 
        d="M11.792,21.308l-1.017,1.017a1.1,1.1,0,0,1-1.553,0l-8.9-8.9a1.1,1.1,0,0,1,0-1.553l8.9-8.9a1.1,1.1,0,0,1,1.553,0l1.017,1.017a1.1,1.1,0,0,1-.018,1.571L6.255,10.815H19.417a1.1,1.1,0,0,1,1.1,1.1V13.38a1.1,1.1,0,0,1-1.1,1.1H6.255l5.519,5.258A1.092,1.092,0,0,1,11.792,21.308Z" 
        transform="translate(0.004 -2.647)" 
        :fill="color"
    />
    </svg>
</template>
<script>
export default {
    props:{
        color:{
            type: String,
            default: '#FFFFFF'
        },
        height:{
            type: String,
            default: '20'
        },
        width:{
            type: String,
            default: '20.52'
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/shared/icons/ArrowIcon.vue